module.exports = __webpack_public_path__ + "img/small.b2e57c18.jpg";